import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { FaLinkedin, FaInstagram, FaGithub } from "react-icons/fa";

const teamMembers = [
  {
    name: "Japneet Rajput",
    role: "Full Stack Dev",
    image:
      "https://images.unsplash.com/photo-1634193295627-1cdddf751ebf?fit=clamp&w=400&h=400&q=80",
  },
  {
    name: "Aayush Talreja",
    role: "Frontend & UI/UX Dev",
    image:
      "https://images.unsplash.com/photo-1634193295627-1cdddf751ebf?fit=clamp&w=400&h=400&q=80",
  },
  {
    name: "Yashvi Dhar",
    role: "[Fill your pos.]",
    image:
      "https://images.unsplash.com/photo-1635003913011-95971abba560?fit=clamp&w=400&h=400&q=80",
  },
  {
    name: "Vishakha Kulkarni",
    role: "[Fill your pos.]",
    image:
      "https://images.unsplash.com/photo-1635003913011-95971abba560?fit=clamp&w=400&h=400&q=80",
  },
  {
    name: "Anurag",
    role: "[Fill your pos.]",
    image:
      "https://images.unsplash.com/photo-1634193295627-1cdddf751ebf?fit=clamp&w=400&h=400&q=80",
  },
  {
    name: "Sujal Patil",
    role: "[Fill your pos.]",
    image:
      "https://images.unsplash.com/photo-1634193295627-1cdddf751ebf?fit=clamp&w=400&h=400&q=80",
  },
];

export default function About() {
  return (
    <>
      <Navbar />
      <div className="flex items-center justify-center min-h-screen bg-[#0D1117] py-20">
        <div className="flex flex-col">
          <div className="flex flex-col mt-8">
            <div className="container max-w-7xl px-4">
              <div className="flex flex-wrap justify-center text-center mb-24">
                <div className="w-full lg:w-8/12 px-4">
                  <h1 className="text-gray-200 text-4xl font-bold mb-8">
                    Meet the Team
                  </h1>

                  <p className="text-gray-400 text-lg font-light">
                    With over 3 years of combined experience, we've got a
                    well-seasoned team at the xyz.
                  </p>
                </div>
              </div>

              <div className="flex flex-wrap">
                {teamMembers.map((member, index) => (
                  <div
                    key={index}
                    className="w-full md:w-6/12 lg:w-4/12 mb-6 px-6 sm:px-6 lg:px-4"
                  >
                    <div className="flex flex-col">
                      <a href="#" className="mx-auto">
                        <img
                          className="rounded-2xl drop-shadow-md hover:drop-shadow-xl transition-all duration-200 delay-100"
                          src={member.image}
                          alt={member.name}
                        />
                      </a>

                      <div className="text-center mt-6">
                        <h1 className="text-gray-300 text-xl font-bold mb-1">
                          {member.name}
                        </h1>

                        <div className="text-gray-500 font-light mb-2">
                          {member.role}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
